import styled from 'styled-components';

export const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AccordionItem = styled.div`
  border-bottom: 1px solid #ddd;
  border-radius: 4px;
  span {
    flex-shrink: 0;
  }

  &:nth-last-child(1) {
    border-bottom: 1px solid #ddd;
  }
`;
export const AccordianTitleInner = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  a {
    color: #0000e8;
    font-weight: 300;
  }
`;
export const AccordionTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 12px;
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 87%);
  justify-content: space-between;
  font-size: clamp(16px, 2vw, 20px);

  @media (min-width: 768px) {
    cursor: pointer;
  }
`;
export const AccordionHeading = styled.div`
  font-size: clamp(16px, 2vw, 18px);
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  padding-left: 12px;
  padding-bottom: 8px;
  padding-top: ${(props) => (props.lactoMama ? '24px' : '16px')};
`;
export const AccordionContent = styled.div`
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease;
  font-size: 13px;
  padding: 0 10px;
  color: rgba(0, 0, 0, 0.8);
  p {
    padding: 0 0 16px;
    line-height: 1.5;
  }

  &.extendHeight {
    max-height: 100%;
    padding-bottom: ${(props) => (props.tool ? '16px' : '')};
  }
  ul {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    padding: 0 10px 0 18px;
    list-style: disc;

    li {
      padding: 0 0 8px;
    }
  }
  a {
    color: #0000e8;
  }
`;
export const AccordianContentCarousel = styled.div`
  display: flex;
  overflow: auto;
  max-height: 0;
  transition: max-height 0.3s ease;

  font-size: clamp(14px, 2vw, 16px);
  ::-webkit-scrollbar {
    display: none;
  }

  p {
    padding: 0 0 16px;
  }

  div {
    margin: 0px 10px;
    min-width: 248px;
    padding-bottom: 16px;
    img {
      width: 100%;
    }
  }

  &.extendHeight {
    max-height: 816px;
  }
  ul {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    padding: 0 10px 0 18px;
    list-style: disc;

    li {
      padding: 0 0 8px;
    }
  }
  a {
    color: #0000e8;
  }
`;
